import React, {useContext, useEffect, useState} from "react";
import {RecordsManagementContext, ViewMangementContext} from "../StatesMangement/InitialiseContext";
import axios from "axios";
import {
    Elink,
    FetchEstimateRoomsAndInventoriesUrl, LastPageVisited, ClientPortalUrl
} from "../CommonComponents/Routes";
import UpdateFloorModal from "./UpdateFloorModal";
import {Modal} from "react-bootstrap";
import {Animation} from "./Animation"
import MobileLinkLoader from "./MobileLinkLoader"
import {AnimationPrevious} from "./AnimationPrevious";
import {GetTextColor} from "./GetTextColor";

export default () => { // this component is used to show rooms and inventories details on review and submit page
    const RecordController = useContext(RecordsManagementContext);
    const PageView = useContext(ViewMangementContext);
    let JobIsOpen = RecordController.IsCustomerEditEstAftrBook;
    const [BodyState, setBodyState] = useState("MINI-LOADING");
    const [GoToCp, SetGoToCp] = useState(true);
    let CustomerInvReq = RecordController.ML_Start.CustomerInventoryRequest;

    useEffect(() => {
        if (RecordController.Click) {
            Animation("inventory-review",RecordController.Click);// add animation class
        }
        axios({// fetching data using post request
            method: 'post',
            url: FetchEstimateRoomsAndInventoriesUrl,
            params: {estimate_key: Elink}
        }).then(async (response) =>{
            await RecordController.SetRoomsAndInventories(response.data.EstimateRoomHash);
            await RecordController.SetCompanyFloors(response.data.CompanyFloors);
            await setBodyState("Get Details");
        });
        axios({// updating customer's last visited of mobile link page
            method: 'post',
            url: LastPageVisited,
            params: {estimate_key: Elink, last_visited_page: 'REVIEW_AND_SUBMIT'}
        });
    }, [])

    const ShowRoomsInventories = (props) =>{// show inventories
        let Room = props.Room;
        let Inventories = Room.Inventories;
        return(
            <>
                <div className="inventory-section">
                        <div className="col-sm-12 col-md-12 col-lg-12 ">
                            <div className="card-inventory">
                                <div className="inventory-body">
                                    <div className="edit" onClick={()=>EditRoomDetail({Room})} style={{cursor: "pointer"}} >
                                        <img src={process.env.PUBLIC_URL + "/Images/edit.png"} alt="edit-image"/>
                                    </div>
                                    <h5 className="inventory-title" style={{color: "black"}}><b>{Room.Name}</b> {Room.ImageCount > 0 ? <i className="fa fa-image" title={'Room Images'}> : {Room.ImageCount}</i> : ''}</h5>
                                    <h6 className="btn btn-sm-2 btn-light" onClick={()=> getCompanyFloors({Room})} >
                                        { RecordController.UpdateFloor && RecordController.Room.Id === Room.Id ? "Updating.." : "Floor: "+ Room.Floor }
                                    </h6>
                                    <ul>
                                        { Object.keys(Inventories).length > 0 ?
                                            Object.entries(Inventories).map(([id, Inventory]) => {
                                                return (
                                                    <RoomInventoryImageCount key={id} Inventory={Inventory}/>
                                                )
                                            })
                                            :""}
                                    </ul>
                                </div>
                            </div>
                        </div>
                </div>
            </>
        )
    }
    const RoomInventoryImageCount = (props)=>{ // this component is used to show image count of custom inventory and room
        return(
            <>
                <li style={{color: "black"}}>{props.Inventory.Name} {props.Inventory.ImageCount > 0 ?
                    <i className="fa fa-image" title={'Inventory Images'}> : {props.Inventory.ImageCount}</i> : ''}</li>
            </>
        )
    }
    const EditRoomDetail = (props) =>{// this component is used to edit the room, it's open new page as room details
        RecordController.setRoom(props.Room);
        RecordController.SetEditRoom(true);
        RecordController.SetClick('upward');
        AnimationPrevious ( "upward-go",  "inventory-review",  "MOBILE_ROOM_DETAIL", PageView);
    }

    const getCompanyFloors = (props) =>{// get company floors
        RecordController.setRoom(props.Room);
        RecordController.setCustomItemModal(true);
    }

    const BackToMyRooms = () =>{ // back to my room page
        RecordController.SetClick('back');
        AnimationPrevious ( "back-go",  "inventory-review",  "SHOW_MOBILE_LINK_MY_ROOMS", PageView);
    }

    const SubmitInventoryPage = () =>{ // it is used show submit inventory page
        RecordController.SetClick('next');
        AnimationPrevious ( "next-go",  "inventory-review",  "SUBMIT_INVENTORY", PageView);
    }

    const openClientPortal = () => { // it is used to open client portal in new tab
        if(GoToCp) {
            SetGoToCp(false);
            axios({
                method: 'post',
                url: ClientPortalUrl,
                params: {estimate_key: Elink}
            }).then(async (response) => {
                let url = response.data.url
                await window.open(url, "_blank");
                await SetGoToCp(true);
            })
        }
    }

    const reviewInventories = () => { // it is used to show the room and inventory details
        return (
            <>
                <Modal className="alert-modal" show={!JobIsOpen || RecordController.ML_Start.InventoryType } onHide={JobIsOpen || !RecordController.ML_Start.InventoryType } id ="keypadModal"
                       style={{borderRadius: "30px",marginTop: "18%"}}>
                    <Modal.Body style={{height:"250px",textAlign: "center"}}> <b style={{fontSize: "115%"}}>
                        <img id="start-img" src={process.env.PUBLIC_URL + "/Images/alert.png"} alt="image" style={{height:"25%"}}/><br/><br/>
                        {
                            RecordController.ML_Start.InventoryType && JobIsOpen ? "This link is not valid for percentage inventory" :
                                "This job is currently booked, please contact your moving company to make any edits."
                        }
                    </b></Modal.Body>
                </Modal>
                <div className="container " style={{maxWidth: "100%"}}>
                    <div className="row new-room-row">
                        <div className="col-md-2 col-lg-3 col-xl-3">
                            <button className="btn-st-back" type="submit" onClick={()=>BackToMyRooms()}
                                    style={{borderRadius: "8px", color: GetTextColor(CustomerInvReq.ButtonColor), backgroundColor: CustomerInvReq.ButtonColor}} >Back</button>
                        </div>
                        <div className="col-12 col-md-8 col-lg-6 col-xl-6" style={{maxWidth: "100%"}}>
                            <div className="header-tx text-center">
                                <div className="arrow-st" onClick={()=>BackToMyRooms()}>
                                    <i className={"fas fa-angle-left"} style={{fontSize: "35px",color: GetTextColor(CustomerInvReq.BackgroundColor)}}></i>
                                </div>
                                <h3 id="inventory-review-h" style={{color: GetTextColor(CustomerInvReq.BackgroundColor)}}>Inventory Review</h3>
                            </div>
                        </div>
                        <div className="col-md-2 col-lg-3 col-xl-3">
                        </div>
                    </div>
                    {
                        // add loader because sometimes it take more time to fetch the data
                        BodyState === "MINI-LOADING" ? <MobileLinkLoader Height={"45vh"}/> :
                        <>
                            <div className={"review_and_submit_div"} style={{marginTop: "4rem"}}>
                                {new URLSearchParams(window.location.search).get('goto') === 'mobile_inventory' ? <></> :
                                    <button type={"submit"} className={" btn-sm go-to-portal-2"} onClick={() => openClientPortal(GoToCp)} disabled={!GoToCp}
                                            style={{position: "relative", marginBottom: "1%", backgroundColor: CustomerInvReq.ButtonColor, color: GetTextColor(CustomerInvReq.ButtonColor)}}>
                                        <b>Go To Customer Portal</b>
                                    </button>
                                }
                                {
                                    // loader is add to get client portal details and open client portal in new tab
                                    !GoToCp ?
                                        <div className={"row text-center"}>
                                            <div className={"col-lg-10 col-md-10 col-sm-8 col-6"} style={{position: "absolute", zIndex: 0}}>
                                                <img src={process.env.PUBLIC_URL + `Images/Loader18.gif`}  alt="LOADING.."
                                                     style={{position: "absolute", zIndex: 1, background: "transparent", width: "250px", height: "335px"}}/>
                                            </div>
                                        </div>
                                        : <></>
                                }
                                <div style={{height: "54vh", overflow: "auto"}}>
                                    {
                                        Object.keys(RecordController.RoomsAndInventories).length > 0 ?
                                            Object.entries(RecordController.RoomsAndInventories).map(([id, Room]) => {
                                                return (<ShowRoomsInventories key={id} Room={Room}/>)
                                            })
                                            : ""
                                    }
                                </div>
                            </div>
                            <UpdateFloorModal Floor={RecordController.Room} For={'Review'}/>
                            <div className="btn-review">
                                <button className="btn-st-review-2" style={{marginTop: "1.5%", backgroundColor: CustomerInvReq.ButtonColor}}
                                        type="submit" onClick={() => SubmitInventoryPage()}><b style={{color: GetTextColor(CustomerInvReq.ButtonColor)}}>SUBMIT INVENTORY</b>
                                    <i className="fa fa-check" aria-hidden="true" style={{color: GetTextColor(CustomerInvReq.ButtonColor)}}></i>
                                </button>
                            </div>
                        </>
                    }
                </div>
            </>
        )
    }


    return(<>
        <section className="item-section-2 desktop-vw" style={{background: CustomerInvReq.BackgroundColor}}>
            <div className={"inventory-review"} style={{width: "100vw", position: "relative"}}>
                {reviewInventories()}
            </div>
        </section>
        <section className="mobile-section-4 mobile-vw" style={{background: CustomerInvReq.BackgroundColor}}>
            <svg id="curve" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1416.99 174.01">
                <path className="curve-path" d="M0,280.8S283.66,59,608.94,163.56s437.93,150.57,808,10.34V309.54H0V280.8Z" transform="translate(0-135.53)" style={{position:"relative"}} fill="#f2f5f8"/>
                <path className="curve-path" d="M77.8,230.3S283.66,353,880.94,275.58s937.93,190.57,920,10.34V309.54H0V280.8Z" transform="translate(0-135.53)" style={{position:"relative"}} fill="white"/>
            </svg>
            <div className={"inventory-review"} style={{width: "100vw", position: "relative"}}>
                {reviewInventories()}
            </div>
        </section>
    </>)
}

